
    document.addEventListener("DOMContentLoaded", function() {
      // Reference the custom dropdown container.
      var customDropdown = document.querySelector('.custom-dropdown');
      if (!customDropdown) return;
  
      // Elements within the dropdown.
      var dropdownSelected = customDropdown.querySelector('.dropdown-selected');
      var dropdownOptions = customDropdown.querySelector('.dropdown-options');
      var hiddenInput = document.getElementById('selectedVariantId');
      var selectedTitle = customDropdown.querySelector('.selected-title');
      var swatchSelected = customDropdown.querySelector('.swatch-selected');
  
      // Toggle dropdown options when clicking on the selected area.
      dropdownSelected.addEventListener('click', function(event) {
        event.stopPropagation();
        dropdownOptions.style.display = (dropdownOptions.style.display === "block") ? "none" : "block";
      });
  
      // Add click events for each dropdown option.
      var options = customDropdown.querySelectorAll('.dropdown-option');
      options.forEach(function(option) {
        option.addEventListener('click', function(event) {
          event.stopPropagation();
          var variantId = this.getAttribute('data-value');
          var optionTitle = this.getAttribute('data-title');
          var swatchImageUrl = this.getAttribute('data-swatch'); // Now an image URL
  
          // Update the hidden input value.
          hiddenInput.value = variantId;
          // Update the dropdown-selected area: text and swatch image.
          selectedTitle.textContent = optionTitle;
          swatchSelected.style.backgroundImage = 'url(' + swatchImageUrl + ')';
          swatchSelected.style.backgroundSize = 'cover';
          swatchSelected.style.backgroundPosition = 'center';
  
          // Hide the dropdown options.
          dropdownOptions.style.display = "none";
        });
      });
  
      // Set default selection on page load.
      var defaultOption = customDropdown.querySelector('.dropdown-option[data-default="true"]');
      if (defaultOption) {
        hiddenInput.value = defaultOption.getAttribute('data-value');
        selectedTitle.textContent = defaultOption.getAttribute('data-title');
        var defaultSwatch = defaultOption.getAttribute('data-swatch');
        swatchSelected.style.backgroundImage = 'url(' + defaultSwatch + ')';
        swatchSelected.style.backgroundSize = 'cover';
        swatchSelected.style.backgroundPosition = 'center';
      } else if (options.length > 0 && !hiddenInput.value) {
        var firstOption = options[0];
        hiddenInput.value = firstOption.getAttribute('data-value');
        selectedTitle.textContent = firstOption.getAttribute('data-title');
        var firstSwatch = firstOption.getAttribute('data-swatch');
        swatchSelected.style.backgroundImage = 'url(' + firstSwatch + ')';
        swatchSelected.style.backgroundSize = 'cover';
        swatchSelected.style.backgroundPosition = 'center';
      }
  
      // Close the dropdown when clicking outside.
      document.addEventListener('click', function(event) {
        if (!event.target.closest('.custom-dropdown')) {
          dropdownOptions.style.display = "none";
        }
      });
    });
